import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname,
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="text-center max-w-md">
        <h1 className="text-4xl font-bold mb-2">404</h1>
        <p className="text-xl text-gray-600 mb-2">Page not found</p>
        <p className="text-sm text-gray-500 mb-6 leading-relaxed">
          We couldn&apos;t find a page at
          <span className="mt-2 block font-mono text-gray-700 break-all">
            {location.pathname}
          </span>
          <span className="mt-2 block">
            Please check the link or go back to the dashboard.
          </span>
        </p>
        <Link
          to="/accesspoint"
          className="text-blue-600 hover:text-blue-800 underline font-medium"
        >
          Go to Access Point
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
